<template>
  <div class="CaseStudiesOption">
    <h3 class="heading">{{ localeStrings.heading }}</h3>
    <div class="items">
      <article v-for="item in items" :key="item._key" class="item">
        <div class="itemImageFrame">
          <SanityImage v-if="item.image" :asset="item.image.asset" class="itemImage"/>
        </div>
        <div class="itemText">
          <h4 class="itemTitle">{{ item.title }}</h4>
          <span @click="whenLinkFollowed(item)">
            <CtaLink
              :action="getPagePath(item)"
              :text="localeStrings.linkText"
              class="itemCta"
            />
          </span>
        </div>
      </article>
    </div>
  </div>
</template>

<script>
import resourcePaths from '~/data/resourcePaths.json'
import formatString from '~/lib/formatString'
import strings from './strings.json'

export default {
  props: {
    items: Array,
    whenLinkFollowed: Function,
  },
  inject: ['locale'],
  computed: {
    localeStrings() {
      return strings[this.locale]?.caseStudiesOption
    },
  },
  methods: {
    getPagePath({ slug }) {
      const pathPattern = resourcePaths[this.locale]?.caseStudy ?? ''
      return formatString(pathPattern, { slug: slug?.current })
    },
  },
}
</script>

<style scoped>

.heading {
  font-weight: 600;
  font-size: var(--font-size-3);
  color: var(--text-color-black);
}

.items {
  margin-top: var(--spacing-5);
  display: flex;
  flex-direction: column;
  row-gap: var(--spacing-6);
}

.item {
  display: flex;
  align-items: flex-start;
  column-gap: var(--spacing-3);
}

.itemImageFrame {
  width: 6.5rem;
  height: 5.5rem;
  flex-shrink: 0;
  border-radius: 0.5rem;
  overflow: hidden;
}

.itemImage {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.itemTitle {

  font-weight: 600;
  font-size: var(--font-size-2);
  line-height: 1.3;
  color: var(--text-color-black);

  /* Clamp to 3 lines */
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow-y: hidden;
}

.itemCta {
  margin-top: var(--spacing-0);
  font-size: var(--font-size-2);
}
</style>
